import React, { useRef, useState , useEffect } from "react";
import styles from "./Time.module.css";
import SquareRadio from '../Utilities/SquareRadio'
import { useTranslation } from "react-i18next";
import DatePicker from "./DatePicker";
import { useDispatch, useSelector} from "react-redux";
import { addCart,editCart,getCarts } from "../../redux/Slices/Cart/thunk";
import { useNavigate } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import notify from "../Utilities/notify";
import Modal from "react-bootstrap/Modal"; 
import Button from "react-bootstrap/Button";
import { getScheduleTime } from "../../redux/Slices/Time/thunk";
import { editService } from "../../redux/Slices/reservation/thunk";

const Time = ({servicesId,servicesId2,reservationNum,isEdit, isEditServisePreducer, cartFromCart}) => {
  const [selectedInput, setSelectedInput] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [selectedEndTime, setSelectedEndTime] = useState();
  const [selectedMin, setSelectedMin] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openModal,setOpenModal]=useState(false)
  const [date, setDate] = useState();
  const { t, i18n } = useTranslation();
  const dispatch= useDispatch();
  const navigate = useNavigate();
  const ServicesCard = JSON.parse(localStorage.getItem("ServicesCard"));
  const CategoriesCard = JSON.parse(localStorage.getItem("card"));
  const user = JSON.parse(localStorage.getItem("user"));
  const empCard = JSON.parse(localStorage.getItem("empCard"));
  console.log("ServicesCard",ServicesCard)
  console.log("CategoriesCard",CategoriesCard)
  console.log("user",user)
  console.log("empCard",empCard)
  console.log("date",date)
  console.log("cartFromCart",cartFromCart)

  const {scheduleTime, loading } = useSelector((state) => state.TimeSlice);
  
  console.log("scheduleTime",scheduleTime)

  const getCurrentDate = (date) => {
  if (!date) return ""; // Handle empty date case

  const [year,month,day] = date.split("-"); // Split the input string by "/"
  console.log("day",day)
  console.log("month",month)
  console.log("year",year)
  return `${year}/${month}/${day}`; // Rearrange to YYYY/MM/DD format
};
  const getRealDate = (date) => {
  if (!date) return ""; // Handle empty date case

  const [year,month,day] = date.split("-"); // Split the input string by "/"
  console.log("day",day)
  console.log("month",month)
  console.log("year",year)
  return `${day}/${month}/${year}`; // Rearrange to YYYY/MM/DD format
};

const realDate = getRealDate(date);
const nowDate = getCurrentDate(date);
console.log("nowDate", nowDate);
console.log("realDate", realDate);

useEffect(() => {
  if (!nowDate) return; // Avoid running effect with an empty date
  let query ;
  // if(isEdit){
  //   query = `empNum=${emp_num}&date=${nowDate}`;

  // }else{
    query = `empNum=${empCard?.empi_num}&date=${nowDate}`;

  // }
  dispatch(getScheduleTime({ query }));
  setSelectedTime();
  setSelectedEndTime();
  setSelectedInput();
}, [nowDate]);



  
  console.log("selectedTime",selectedTime)



const onSubmit = async ()=>{

    const data = {
      brn_num:ServicesCard?.brn_num,
      brn_nam:ServicesCard?.brn_nam,
      brn_enm:ServicesCard?.brn_enm,
      client_id:user?.cln_key,
      emp_num:empCard?.empi_num,
      date:selectedDate,
      time: selectedTime,
      logIn: selectedTime,
      logOut: selectedEndTime,
      service_min:selectedMin,
      emp_nam:empCard?.emp_namar,
      emp_enm:empCard?.emp_namen,
      itm_srl:ServicesCard?.itm_srl,
      itm_nam:ServicesCard?.itm_nam,
      itm_enm:ServicesCard?.itm_enm,
      itm_price:ServicesCard?.prcandtax,
      itm_discount:ServicesCard?.itm_dessal,
      image:`https://reservation.ladycaresa.com/public/uploads${ServicesCard?.itm_IMG}`,
      itm_hassrl:ServicesCard?.itm_hassrl,
      sectionNameAr:CategoriesCard?.cats_nam.trim(),
      sectionNameEn:CategoriesCard?.cats_enm.trim(),
    }
    
    console.log("data",data)

    let toDay = new Date(); 
    console.log("toDay", toDay);
    
    
    let [day, month, year] = realDate.split("/");
    let formattedRealDate = new Date(`${year}-${month}-${day}T23:59:59`);
    
    console.log("formattedRealDate", formattedRealDate , "toDay", toDay);
    
    // Compare dates
    if (formattedRealDate < toDay) {
        return notify(t("date_must_start_from_today"), "error");
    }
    
    // return;
    
    
    if(selectedInput == null || selectedInput == undefined){
      console.log('selectedInput',selectedInput)
      return notify(t("selectDateTimeMessage"),"error")
    }
    // return;
    console.log("reservationNum",reservationNum)
    if(isEdit){
      let editData ={
        type :"main",
        serviceSerial:servicesId2,
        serviceTime:selectedTime,
        servicesDate:selectedDate,
        serviceMin:selectedMin,
        employeeId:empCard?.empi_num,
        logOut:selectedEndTime,
        logIn:selectedTime
        
   
      }
await dispatch(editService({
  id:reservationNum,
  data:editData
}))
navigate('/bookings')
    }else if (isEditServisePreducer){
      const dataEdit = {
        brn_num:cartFromCart?.brn_num.trim(),
        brn_nam:cartFromCart?.brn_nam.trim(),
        brn_enm:cartFromCart?.brn_enm.trim(),
        client_id:user?.cln_key,
        emp_num:empCard?.empi_num,
        date:selectedDate,
        time: selectedTime,
        log_in: selectedTime,
        log_out: selectedEndTime,
        service_min:selectedMin,
        emp_nam:empCard?.emp_namar,
        emp_enm:empCard?.emp_namen,
        itm_srl:cartFromCart?.itm_srl.trim(),
        itm_nam:cartFromCart?.itm_nam.trim(),
        itm_enm:cartFromCart?.itm_enm.trim(),
        itm_price:cartFromCart?.itm_price.trim(),
        itm_discount:cartFromCart?.itm_discount.trim(),
        image:cartFromCart?.image? cartFromCart?.image.trim() : cartFromCart?.image,
        itm_hassrl:cartFromCart?.itm_hassrl.trim(),
        sectionNameAr:cartFromCart?.sectionNameAr.trim(),
        sectionNameEn:cartFromCart?.sectionNameEn.trim(),
      }
      console.log("dataEdit",dataEdit)
      await dispatch(editCart({id:cartFromCart?.cart_srl, data:dataEdit}));
      sessionStorage.removeItem('cartFromCart');
      sessionStorage.removeItem('isEditServisePreducer');
      navigate('/cart')
    }else{
      
      setIsLoading(true)
      const responce =  await dispatch(addCart({data}))
      console.log("responce",responce)
      setIsLoading(false)
      if(responce?.payload){
        setOpenModal(true)
      }
    }
    localStorage.removeItem('card');
    localStorage.removeItem('ServicesCard');
    localStorage.removeItem('empCard');
 


}

const handleNavigate = (path) => {
  setOpenModal(false);
  navigate(path);
};

const onChangeHandlar = (slot, index) => {
  console.log("Selected Slot:", slot); 
  setSelectedInput(index);
  setSelectedDate(slot?.schd_dat);
  setSelectedTime(slot?.schd_timein);
  setSelectedEndTime(slot?.schd_timeout);
  setSelectedMin(slot?.schd_servicetime);
  console.log("selectedInput",selectedInput)
};

  return (
    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
    
<div className={styles.mainContainer} >



<DatePicker setDate={setDate} />
{loading ?  <div style={{display:"flex", justifyContent:"center"}}>
           
           <Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
          </div> 
          : 
      <div className={styles.TimeComponant}>
      {scheduleTime?.length > 0 ?  <>
      
      {scheduleTime?.map((slot, index) => (
            <div key={index} style={{ opacity: (slot?.balcount <= 0 || ServicesCard?.itm_hassrl > slot?.schd_servicetime || slot?.is_disabled) ? 0.5 : 1 }} className="d-flex justify-content-between">
               <SquareRadio
                value={selectedInput == index}
                onChange={() => onChangeHandlar(slot,index)}
                name="timeRange"
                checked={selectedInput == index}
                disabled={slot.balcount <= 0 || ServicesCard?.itm_hassrl > slot?.schd_servicetime || slot?.is_disabled} 
                // disabled={slot.isDisabled}
              />

              <div>{t('from')}</div>
              <div className={styles.TimeBox} >
                <span style={{textAlign:"center", margin:"auto"}}>{slot?.schd_timein}</span>
              </div>
              <div>{t('to')}</div>
              <div className={styles.TimeBox} >
                <span style={{textAlign:"center", margin:"auto"}}>{slot?.schd_timeout}</span>
              </div>
            </div>
          ))}

</> : <div
  style={{
    background: "#ffdddd", // Light red background
    color: "#d9534f", // Dark red text
    padding: "10px 20px",
    borderRadius: "8px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "18px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "20px auto",
    width: "100%",
    border: "1px solid #d9534f"
  }}
>
  {t('no_available_appointments')}
</div>
}
    </div>}

  
    </div>
    <div className={styles.onSubmit} onClick={onSubmit} disabled={isLoading} >
           { isLoading ? <Spinner /> : t('send')} 
          </div>

          {/* Modal */}

          <Modal show={openModal} onHide={() => {}} backdrop="static" keyboard={false}>
<div style={{display:"flex", justifyContent:"center", alignItems:"center", padding:"10px"}}>
          <Modal.Title>{t("yourOrderIsSend")}</Modal.Title>
</div>


      <div style={{display:"flex", flexDirection:"column", gap:"10px", padding:"20px"}}>
      <Button variant="primary" onClick={() => handleNavigate("/cart")} style={{ backgroundColor: "#B49345", borderColor: "#B49345" }}      >
            {t("goToCart")}
          </Button>
          <Button variant="secondary" onClick={() => handleNavigate("/categories")}>
            {t("continueShopping")}
          </Button>
      </div>
        
      </Modal>
    </div>
  );
};

export default Time;
